// extracted by mini-css-extract-plugin
module.exports = {"mb-btn":"btn_mb-btn__1u9W7","simple":"btn_simple__1MRc7","clean":"btn_clean__31fd_","link":"btn_link__3RjkW","solid":"btn_solid__1xcyh"};